import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuStorageTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8501 13.5299C17.7701 13.3499 17.6301 13.1999 17.4401 13.1199C17.3501 13.0799 17.2501 13.0599 17.1501 13.0599H6.8501C6.4401 13.0599 6.1001 13.3999 6.1001 13.8099C6.1001 14.2199 6.4401 14.5599 6.8501 14.5599H15.3501L13.5901 16.3199C13.3001 16.6099 13.3001 17.0899 13.5901 17.3799C13.7401 17.5299 13.9301 17.5999 14.1201 17.5999C14.3101 17.5999 14.5001 17.5299 14.6501 17.3799L17.6901 14.3399C17.7601 14.2699 17.8101 14.1899 17.8501 14.0999C17.9201 13.9199 17.9201 13.7099 17.8501 13.5299Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.15016 10.47C6.23016 10.65 6.37016 10.8 6.56016 10.88C6.65016 10.92 6.75016 10.94 6.85016 10.94H17.1602C17.5702 10.94 17.9102 10.6 17.9102 10.19C17.9102 9.77997 17.5702 9.43997 17.1602 9.43997H8.66016L10.4202 7.67997C10.7102 7.38997 10.7102 6.90997 10.4202 6.61997C10.1302 6.32997 9.65016 6.32997 9.36016 6.61997L6.32016 9.64997C6.25016 9.71997 6.19016 9.80997 6.15016 9.89997C6.08016 10.08 6.08016 10.29 6.15016 10.47Z",
			fill: "#FFFFFF"
		})
	]
});
export default SvgMenuStorageTransfer;
